import { Header } from "antd/lib/layout/layout";
import "./index.css";
import { Dropdown, Menu } from "antd";
import { CaretDownOutlined } from "@ant-design/icons";
import { OtherAction, sendOtherEvent } from "../../components/matomoClient";
import AppHeaderLink from "../../components/appHeaderLink";

const AppHeader = (props) => {
  const menu = () => {
    const handleLogout = async (e) => {
      e.preventDefault();
      await props.logout();
      sendOtherEvent(OtherAction.Logout);
    };

    return (
      <Menu>
        <Menu.Item>
          <a
            href="/"
            onClick={handleLogout}
          >
            Logout
          </a>
        </Menu.Item>
      </Menu>
    );
  };

  return (
    <Header className={"appHeader"}>
      <div className={"userName"}>
        <AppHeaderLink/>
        <Dropdown
          trigger={["hover"]}
          overlay={menu}
        >
          <a
            href={"/"}
            className="ant-dropdown-link headerFontStyle"
            onClick={(e) => e.preventDefault()}
          >
            Hi, {props.name}
            <CaretDownOutlined style={{ marginLeft: "10px", color: "#5F9FAB" }}/>
          </a>
        </Dropdown>
      </div>
    </Header>
  );
};

export default AppHeader;
